import React, { useState } from 'react'
import { Badge } from 'antd'
import allow from '../../../images/confirm-allow.png'

const TimeList = (props) => {
  const [hover, setHover] = useState(false)
  return (
    <div
      className="more-time"
      style={{ textAlign: 'right', width: 'auto' }}
      onMouseEnter={(e) => setHover(true)}
      onMouseLeave={(e) => setHover(false)}
    >
      更多
      {hover && (
        <div className="time-list">
          <img className="confirm-allow" src={allow} alt="" />
          <div className="time-bg">
            {props.isPreset &&
              props.day.bucket.map((time, index) => {
                const startTime = time.onWork?.photoTime
                const endTime = time.offWork?.photoTime
                return (
                  <li key={index}>
                    <Badge
                      status={startTime && endTime ? 'success' : 'error'}
                      text={
                        <>
                          <span
                            style={{ width: '40px', display: 'inline-block' }}
                          >
                            {startTime}
                          </span>
                          <span>-</span>
                          <span
                            style={{ width: '40px', display: 'inline-block' }}
                          >
                            {endTime}
                          </span>
                        </>
                      }
                    />
                  </li>
                )
              })}
          </div>
        </div>
      )}
    </div>
  )
}

export default TimeList
